import { createFeatureSelector } from '@ngrx/store';
import { type ThemeFeatureState, THEME_FEATURE_STORE_KEY } from './theme-feature.reducer';

export const selectThemeState = createFeatureSelector<ThemeFeatureState>(THEME_FEATURE_STORE_KEY);
